import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Link
    to=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="dropdown-link"
  >
    {children}
  </Link>
));

export default function HeaderMobileNav({
  menus,
  mobileMenuOpenKey,
  setMobileMenuOpenKey,
  isPrimaryMenuActive,
  isRouteActive,
}) {
  return (
    <Dropdown
      className="header-mobile-nav d-lg-none"
      align="end"
      onToggle={(nextShow) => {
        if (!nextShow) setMobileMenuOpenKey("");
      }}
    >
      <Dropdown.Toggle as={CustomToggle}>
        <i className="ri-align-justify"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu className="mt-10-f">
        {menus.map((menu) => {
          const submenuItems = Array.isArray(menu.submenu) ? menu.submenu : [];
          const hasSubmenu = submenuItems.length > 0;
          const isOpen = mobileMenuOpenKey === menu.key;

          if (!hasSubmenu) {
            return (
              <Dropdown.Item
                as={Link}
                key={menu.key}
                to={menu.link}
                className={`fw-bold ${isPrimaryMenuActive(menu) ? "active" : ""}`}
                onClick={() => setMobileMenuOpenKey("")}
              >
                {menu.label}
              </Dropdown.Item>
            );
          }

          return (
            <div key={menu.key} className={"header-mobile-nav-group" + (isOpen ? " show" : "")}>
              <button
                type="button"
                className={`dropdown-item fw-bold header-mobile-nav-toggle w-100 ${isPrimaryMenuActive(menu) ? "active" : ""}`}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  setMobileMenuOpenKey((prev) => (prev === menu.key ? "" : menu.key));
                }}
                aria-expanded={isOpen}
              >
                {menu.label}
                <i className="ri-arrow-down-s-line ms-auto"></i>
              </button>
              <div className="header-mobile-nav-submenu">
                {submenuItems.map((submenu) => (
                  <Dropdown.Item
                    as={Link}
                    key={`${menu.key}-${submenu.link}`}
                    to={submenu.link}
                    className={`fw-bold ${isRouteActive(submenu.link) ? "active" : ""}`}
                    onClick={() => setMobileMenuOpenKey("")}
                  >
                    {submenu.label}
                  </Dropdown.Item>
                ))}
              </div>
            </div>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
